import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type TagFilterButtonGroupProps = {
  tags: string[]
  // Empty selection means "Alle": every course is shown, including untagged ones.
  selectedTags: ReadonlySet<string>
  onChange: (selectedTags: Set<string>) => void
  className?: string
}

const chipClassName =
  'h-7 shrink-0 rounded-full px-3 py-0 font-nav text-[11px] font-bold uppercase tracking-wider'

export function TagFilterButtonGroup({
  tags,
  selectedTags,
  onChange,
  className,
}: TagFilterButtonGroupProps) {
  if (!tags.length) {
    return null
  }

  function toggleTag(tag: string) {
    const next = new Set(selectedTags)
    if (next.has(tag)) {
      next.delete(tag)
    } else {
      next.add(tag)
    }
    onChange(next)
  }

  function renderChip(key: string, label: string, active: boolean, onClick: () => void) {
    return (
      <Button
        key={key}
        type="button"
        variant="ghost"
        size="sm"
        aria-pressed={active}
        onClick={onClick}
        className={cn(
          chipClassName,
          active
            ? 'bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground'
            : 'bg-primary/10 text-primary hover:bg-primary/15 hover:text-primary',
        )}
      >
        {label}
      </Button>
    )
  }

  return (
    <div role="group" aria-label="Kurse nach Tags filtern" className={cn('flex gap-1.5', className)}>
      {renderChip('all', 'Alle', selectedTags.size === 0, () => onChange(new Set()))}
      {tags.map((tag) => renderChip(`tag-${tag}`, tag, selectedTags.has(tag), () => toggleTag(tag)))}
    </div>
  )
}
